import { useEffect } from 'react';
import { MessagePopup } from '@/components/messages/message-popup';
import { useMessageStore } from '@/stores/message-store';
import { useMessageSocket } from '@/hooks/use-message-socket';
import { useAuthStore } from '@/stores/auth-store';
import { messagesApi } from '@/lib/api/messages';

export function MessageProvider({ children }: { children: React.ReactNode }) {
  const { currentPopup, isPopupOpen, dismissPopup, enqueuePopup, setUnreadCount } =
    useMessageStore();
  const accessToken = useAuthStore((s) => s.accessToken);

  useMessageSocket();

  useEffect(() => {
    if (!accessToken) return;

    const fetchUnread = async () => {
      try {
        const unread = await messagesApi.getUnreadCount();
        setUnreadCount(unread.total);

        if (unread.total > 0) {
          const inbox = await messagesApi.getInbox({ unreadOnly: true, limit: 10 });
          for (const item of inbox.data) {
            enqueuePopup({
              conversationId: item.conversationId,
              type: item.conversation.type,
              title: item.conversation.title,
              senderName:
                item.conversation.sender?.displayName ||
                item.conversation.sender?.email ||
                'Admin',
              priority: item.conversation.priority,
            });
          }
        }
      } catch (err) {
        console.error('Failed to fetch unread messages:', err);
      }
    };

    fetchUnread();
  }, [accessToken]);

  return (
    <>
      {children}
      <MessagePopup event={currentPopup} open={isPopupOpen} onDismiss={dismissPopup} />
    </>
  );
}
